/* eslint-disable linebreak-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  CoreService,
  IResponse
} from 'src/app/@amiga-pyme/services/core.service';
import { lastValueFrom, Observable, Subject } from 'rxjs';

type TRouteBase = `/${string}`;
interface IRoutesCrud {
  register?: string;
  list?: string;
  update?: string;
  remove?: string;
  getById?: string;
  updateWithoutId?: string;
}
type TMethods = 'register' | 'list' | 'update' | 'remove';
@Injectable({
  providedIn: 'root'
})
export class CrudService extends CoreService {
  routesCrud: IRoutesCrud;
  route: string;
  data$: Subject<any[]>;
  constructor(http: HttpClient, routeBase: TRouteBase) {
    super(http);
    this.route = routeBase;
    this.routesCrud = {
      register: routeBase,
      list: routeBase,
      getById: routeBase + '/:id',
      update: routeBase + '/:id',
      updateWithoutId: routeBase,
      remove: routeBase + '/:id'
    };
    this.data$ = new Subject();
    // this.getNewMessageSocket();
  }

  sendMessageSocket(method: TMethods) {
    // this.socketService.socket.emit(`${this.route}:${method}`, {});
  }

  getNewMessageSocket = () => {
    // this.socketService.socket.on(`${this.route}:list`, () => {
    //   this.list(true);
    // });
  };

  getData$(): Observable<any[]> {
    this.list();
    return this.data$.asObservable();
  }

  async list(clearCache = false) {
    try {
      const httpResponse = await lastValueFrom(
        this.request({ method: 'GET', url: this.routesCrud.list, clearCache })
      );
      const { data, ...response } = this.refactorResponse(httpResponse);
      this.data$.next(data as any);
      return response;
    } catch (err) {
      return this.refactorErrorResponse(err);
    }
  }

  async getById(id: number): Promise<IResponse> {
    try {
      const response = await lastValueFrom(
        this.request({
          method: 'GET',
          url: this.routesCrud.getById.replace(':id', id.toString())
        })
      );
      return this.refactorResponse(response);
    } catch (err) {
      return this.refactorErrorResponse(err);
    }
  }

  async updateWithoutId(id: number, fieldsToUpdate: any): Promise<IResponse> {
    try {
      const response = await lastValueFrom(
        this.request({
          method: 'PUT',
          url: this.routesCrud.updateWithoutId,
          data: fieldsToUpdate
        })
      );
      // this.sendMessageSocket('update');
      return this.refactorResponse(response);
    } catch (err) {
      return this.refactorErrorResponse(err);
    }
  }

  async delete(id: number): Promise<IResponse> {
    try {
      const response = await lastValueFrom(
        this.request({
          method: 'DELETE',
          url: this.routesCrud.remove.replace(':id', String(id))
        })
      );
      // this.sendMessageSocket('remove');
      return this.refactorResponse(response);
    } catch (err) {
      return this.refactorErrorResponse(err);
    }
  }

  async update(id: number, fieldsToUpdate: any): Promise<IResponse> {
    try {
      const response = await lastValueFrom(
        this.request({
          method: 'PUT',
          url: this.routesCrud.update.replace(':id', String(id)),
          data: fieldsToUpdate
        })
      );
      // this.sendMessageSocket('update');
      return this.refactorResponse(response);
    } catch (err) {
      return this.refactorErrorResponse(err);
    }
  }

  async register(fieldsToRegister: any): Promise<IResponse> {
    try {
      const response = await lastValueFrom(
        this.request({
          method: 'POST',
          url: this.routesCrud.register,
          data: fieldsToRegister
        })
      );
      // this.sendMessageSocket('register');
      return this.refactorResponse(response);
    } catch (err) {
      return this.refactorErrorResponse(err);
    }
  }
}
